<div *ngIf="isObjectNotFound()">
  <h1>{{ 'errors.standard.objectNotFoundTitle' | translate}}</h1>
  <p *ngIf="objectId" [innerHTML]="'errors.standard.objectNotFoundParagraph1' | translate: {id: objectId}"></p>
  <p [innerHTML]="'errors.standard.objectNotFoundParagraph2' | translate"></p>
  <p [innerHTML]="'errors.standard.objectNotFoundParagraph3' | translate"></p>
</div>
<ngb-alert *ngIf="isGenericError()" type='danger' [dismissible]="false">
  <div [innerHTML]="genericErrorTranslationCode()"></div>
</ngb-alert>
